export default "__VITE_ASSET__jFShLqPe__"